"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CornerLeftIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.CornerLeftIcon = (0, react_1.forwardRef)(function CornerLeftIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.3297 16.9512C13.1421 17.1387 12.8878 17.244 12.6227 17.244C12.3575 17.244 12.1032 17.1387 11.9157 16.9512L7.67267 12.7082C7.4852 12.5207 7.37988 12.2664 7.37988 12.0012C7.37988 11.7361 7.4852 11.4818 7.67267 11.2942L11.9157 7.05024C12.1043 6.86808 12.3569 6.76729 12.6191 6.76957C12.8813 6.77185 13.1321 6.87702 13.3175 7.06242C13.5029 7.24783 13.6081 7.49865 13.6103 7.76084C13.6126 8.02304 13.5118 8.27564 13.3297 8.46424L9.79467 12.0002L13.3297 15.5352C13.4226 15.6281 13.4964 15.7384 13.5467 15.8598C13.5971 15.9812 13.623 16.1113 13.623 16.2427C13.623 16.3742 13.5971 16.5043 13.5467 16.6257C13.4964 16.7471 13.4226 16.8574 13.3297 16.9502V16.9512Z", fill: "currentColor" })));
});
